<!--
/**
* @name: Add.vue
* @description: 评价管理详情
* @author: 杨波
* @create: 2020/09/08 10:39:33
* @update: 2020/09/08 10:39:33
*/
-->

<template>
  <y-view title="评价详情" :loading="isLoading">
    <y-form titleAlign="left" titleWidth="40px" contentWidth="500px">
      <y-form-item title="订单号：">{{ commentPara.orderNo }}</y-form-item>
      <y-form-item title="销售渠道：">{{ commentPara.saleChannelName }}</y-form-item>
      <y-form-item title="状态：">{{ commentPara.status == "WAIT" ? "待审批" : commentPara.status == "SUCCESS" ? "已审批" : "驳回" }}</y-form-item>
      <y-form-item title="创建时间：">{{ commentPara.createTime }}</y-form-item>
      <y-form-item title="商品货号：">{{ commentPara.goodsCodeSale }}</y-form-item>
      <y-form-item title="商品名称：">{{ commentPara.goodsNameSale }}</y-form-item>
      <y-form-item title="评价内容：">{{ commentPara.content }}</y-form-item>
      <y-form-item title="敏感词：">{{ commentPara.sensitiveWords }}</y-form-item>
      <y-form-item title="评价图片：" align="top">
        <div class="row">
          <img v-for="(item, index) in commentPara.goodsCommentPictureVOList" :key="index" :src="item.url" alt="" :class="css.img_list" />
        </div>
      </y-form-item>
      <y-form-item title="" align="top" v-if="commentPara.status == 'WAIT'">
        <div :class="css.btn_box">
          <k-button :class="css.btn" type="primary" @click="onBatchAudit">审批</k-button>
          <k-button :class="css.btn" type="primary" @click="onBatchReject">驳回</k-button>
        </div>
      </y-form-item>
    </y-form>
  </y-view>
</template>

<script>
import { NESTLE_GOODS_BACK_SERVER_GOODS_COMMENT_DETAIL, NESTLE_GOODS_BACK_SERVER_GOODS_COMMENT_AUDIT, NESTLE_GOODS_BACK_SERVER_GOODS_COMMENT_REJECT } from "@/assets/modules/apiList";
export default {
  data() {
    return {
      isLoading: false,
      commentPara: {},
    };
  },
  methods: {
    getCommentDetail(id) {
      this.isLoading = true;
      this.$fetch({
        api: NESTLE_GOODS_BACK_SERVER_GOODS_COMMENT_DETAIL,
        para: { id },
      })
        .then((res) => {
          this.commentPara = res;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    onBatchAudit() {
      const { tip } = this.$root;
      this.$dialog({
        title: "提示",
        content: "是否确认审批当前选中评价？",
        ok: () => {
          this.isLoading = true;
          this.$fetch({
            api: NESTLE_GOODS_BACK_SERVER_GOODS_COMMENT_AUDIT,
            para: { idList: [this.commentPara.id] },
          })
            .then(() => {
              this.isLoading = false;
              this.getCommentDetail(this.commentPara.id);
            })
            .catch(() => {
              this.isLoading = false;
            });
        },
      });
    },
    onBatchReject() {
      const { tip } = this.$root;
      this.$dialog({
        title: "提示",
        content: "是否确认驳回当前选中评价？",
        ok: () => {
          this.isLoading = true;
          this.$fetch({
            api: NESTLE_GOODS_BACK_SERVER_GOODS_COMMENT_REJECT,
            para: { idList: [this.commentPara.id] },
          })
            .then(() => {
              this.isLoading = false;
              this.getCommentDetail(this.commentPara.id);
            })
            .catch(() => {
              this.isLoading = false;
            });
        },
      });
    },
  },
  created() {
    const { id } = this.$route.query;
    if (id) {
      this.getCommentDetail(id);
    }
  },
  beforeRouteUpdate(to, from, next) {
    const { id } = to.query;
    console.log("Aaaaaaa", id);
    this.commentPara = {};
    if (id) {
      this.getCommentDetail(id);
    }
    next();
  },
};
</script>

<style lang="postcss" module="css">
.img_list {
  margin-right: 20px;
}
.btn_box {
  text-align: center;
  .btn {
    width: 80px;
  }
}
</style>
